import { useEffect, useMemo } from 'react';
import DataTable from 'components/LynDataTable/DataTable';
import { Button, Spin, Tooltip } from 'antd';
import viewIcon from 'assets/images/table-icons/view_blue.svg';
import editIcon from 'assets/images/table-icons/edit_green.svg';
import deleteIcon from 'assets/images/table-icons/delete_red.svg';
import { toast } from 'react-toastify';
import { toastConfig } from 'config';
import { useNavigate } from 'react-router-dom';
import { useDeleteCommitteeMutation } from 'store/features/comptroller/comptrollerApi';

function ListViewCommittee({ userPreferenceTable = [], isLoading, solutionOptions = [], userListMap, employeeListOptions, exisitingTaskListMap }) {
	const [DeleteCommittee, { data: deleteCommitteData }] = useDeleteCommitteeMutation();

	const navigate = useNavigate();
	const onDelete = (id) => {
		DeleteCommittee({
			id: id,
		});
	};

	useEffect(() => {
		if (deleteCommitteData?.code === '200') {
			toast.success('Property deleted successfully', toastConfig);
		} else if (deleteCommitteData?.code !== '200' && deleteCommitteData) {
			toast.error('Property deletion error!', toastConfig);
		}
	}, [deleteCommitteData]);

	// ==============================|| TABLE - HEADER ||============================== //
	const COLUMNS = useMemo(
		() => [
			{
				Header: 'Committee Name',
				accessor: 'title',
			},
			{
				Header: 'Purpose',
				accessor: 'purpose',
			},
			{
				Header: 'From Date',
				accessor: 'fromDateModel',
				Cell: (cell) => {
					return cell?.row?.original?.fromDateModel.dateString;
				},
			},

			// {
			//   Header: "Members",
			//   // show committee members as comma separated string
			//   accessor: "committeeMembers",
			//   Cell: (cell) => {
			//     console.log(cell);
			//     return cell?.row?.original?.committeeMembers
			//       ?.map((member) => {
			//         return member;
			//       })
			//       .join(", ");
			//   },
			// },
			{
				Header: 'Action',
				Cell: (cell) => (
					<div style={{ textAlign: 'center' }}>
						<Tooltip title="View">
							<Button
								type="text"
								icon={<img src={viewIcon} width={16} height={16} alt="view" />}
								onClick={(e) => {
									e.stopPropagation();
									navigate('/static/committee/details', { state: { committeeDetailsState: cell?.row?.original } });
								}}
							></Button>
						</Tooltip>
						<Tooltip title="Edit">
							<Button
								type="text"
								icon={<img src={editIcon} width={16} height={16} alt="edit" />}
								onClick={(e) => {
									e.stopPropagation();
									navigate('/static/committee/edit', { state: { committeeDetailsState: cell?.row?.original } });
								}}
							></Button>
						</Tooltip>
						<Tooltip title="Delete">
							<Button
								type="text"
								icon={<img src={deleteIcon} width={16} height={16} alt="delete" />}
								onClick={(e) => {
									e.stopPropagation();
									onDelete(cell.row.original.id);
								}}
							></Button>
						</Tooltip>
					</div>
				),
				disableSortBy: 'true',
				align: 'center',
			},
		], //eslint-disable-next-line
		[solutionOptions, userListMap, employeeListOptions, exisitingTaskListMap]
	);

	return (
		<Spin spinning={isLoading}>
			<DataTable
				DATA={userPreferenceTable}
				onClickHandler={(row) => {
					navigate('/static/committee/details', { state: { committeeDetailsState: row } });
				}}
				COLUMNS={COLUMNS}
				xlsxFileName="user-preferences"
			/>
		</Spin>
	);
}

export default ListViewCommittee;
